import { useContext } from 'react';
import { AlertContext } from '../providers';

type AlertContextValue = {
  showAlert: (opts: { title?: string; message: string; severity?: string }) => void;
  hideAlert: (...args: any[]) => void;
};

const useAlert = (): AlertContextValue => useContext(AlertContext) as unknown as AlertContextValue;

export default useAlert;
